/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestItem from './lab-test-item';
import LabTestItemDetail from './lab-test-item-detail';
import LabTestItemUpdate from './lab-test-item-update';
import LabTestItemDeleteDialog from './lab-test-item-delete-dialog';

const LabTestItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestItem />} />
    <Route path="new" element={<LabTestItemUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestItemDetail />} />
      <Route path="edit" element={<LabTestItemUpdate />} />
      <Route path="delete" element={<LabTestItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestItemRoutes;
